


























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { QRcodeLayer } from "@/model/document2/page/surface/design/layer/qrcodeLayer";

import QRcodeMarginController from "./qrcodeMarginController/qrcodeMarginController.vue";
import QRcodeErrorController from "./qrcodeErrorController/qrcodeErrorController.vue";
import QRcodeVersionController from "./qrcodeVersionController/qrcodeVersionController.vue";

@Component({
    components: {
        QRcodeMarginController,
        QRcodeErrorController,
        QRcodeVersionController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class QRcodeController extends Vue 
{
    @Prop() layer! : QRcodeLayer;

    private qrcodeControllerType = "qrcodeMargin";

    private isActive(type)
    {
        return this.qrcodeControllerType == type;
    }

    private changeType(type : string)
    {
        this.qrcodeControllerType = type;
    }

    private onChangeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changeLayerProperty", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private changeText()
    {
        var parameter = {};
        parameter["propertyName"] = "text";
        parameter["type"] = "string";
        parameter["currentValue"] = this.layer.text;
        this.$emit("doCommand", "sendNativeEvent", {
            message : "request_layer_property",
            parameter : parameter
        });
    }
}
